import React from 'react';
import { ReactComponent as Logo } from '@assets/logo.svg';
import { useAuth } from '@contexts/AuthContext';
import Button from '@components/common/Button';
import clsx from 'clsx';
import styles from './LoginForm.module.css';
import { isMsalProvider } from '@config/authConfig';

const LoginForm: React.FC = () => {
  const { login, isLoading, error } = useAuth();

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <div className={styles.header}>
          <div className={styles.logo}>
            <Logo width={48} height={48} aria-label="RZ Strategies" />
          </div>
          <h1 className={styles.title}>RZ Strategies</h1>
          <p className={styles.subtitle}>Supplier Risk Assessment System</p>
        </div>

        {error && <div className={styles.error}>{error}</div>}

        <Button
          type="button"
          variant="primary"
          size="lg"
          className={clsx(styles.button, isMsalProvider ? styles.microsoftSigninButton : styles.signinButton)}
          loading={isLoading}
          loadingText="Redirecting..."
          disabled={isLoading}
          onClick={() => login()}
        >
          {isMsalProvider ? (
            <>
              <img src="/microsoft-logo.svg" alt="Microsoft" className={styles.microsoftLogo} />
              <span>Sign in with Microsoft</span>
            </>
          ) : (
            'Sign in with SSO'
          )}
        </Button>
      </div>
    </div>
  );
};

export default LoginForm;
